export interface HeroCopy {
  line1: string
  accent: string
  underline: string
  lede: string
  primaryCta: string
  trustA: string
  trustB: string
  trustC: string
  cardResultLabel: string
  cardBoostTitle: string
  cardBoostSubtitle: string
  cardRankTitle: string
  cardRankSubtitle: string
}

export const HERO_COPY_BY_LANGUAGE: Record<string, HeroCopy> = {
  en: {
    line1: 'Predict football.',
    accent: 'Compete',
    underline: 'friends.',
    lede:
      'With Zporti, compete with friends, go 1v1 or create a group, design your own avatar, and enjoy multiple prediction formats. Download the app or play free on the web.',
    primaryCta: 'Start playing free',
    trustA: 'Free to play, no gambling',
    trustB: 'Live scoring',
    trustC: 'Private groups',
    cardResultLabel: 'Correct result',
    cardBoostTitle: 'Boost active',
    cardBoostSubtitle: '×2 points this match',
    cardRankTitle: 'You moved up to #2',
    cardRankSubtitle: 'Co-founders league',
  },
  es: {
    line1: 'Predice futbol.',
    accent: 'Compite',
    underline: 'con amigos.',
    lede:
      'Zporti convierte cada partido en una competencia de toda la temporada con tus amigos, familia u oficina.',
    primaryCta: 'Empieza gratis',
    trustA: 'Gratis, sin apuestas',
    trustB: 'Puntuacion en vivo',
    trustC: 'Grupos privados',
    cardResultLabel: 'Resultado correcto',
    cardBoostTitle: 'Boost activo',
    cardBoostSubtitle: '×2 puntos este partido',
    cardRankTitle: 'Subiste al #2',
    cardRankSubtitle: 'Liga de cofundadores',
  },
  fr: {
    line1: 'Pronostique le football.',
    accent: 'Affrontez',
    underline: 'vos amis.',
    lede:
      'Zporti transforme chaque match en competition de saison avec vos amis, votre famille ou votre equipe.',
    primaryCta: 'Commencer gratuitement',
    trustA: 'Gratuit, sans pari',
    trustB: 'Scores en direct',
    trustC: 'Groupes prives',
    cardResultLabel: 'Resultat correct',
    cardBoostTitle: 'Boost actif',
    cardBoostSubtitle: '×2 points sur ce match',
    cardRankTitle: 'Vous etes passe #2',
    cardRankSubtitle: 'Ligue des cofondateurs',
  },
  de: {
    line1: 'Tippe auf Fussball.',
    accent: 'Wettstreite',
    underline: 'mit Freunden.',
    lede:
      'Zporti macht jedes Spiel zu einem Saisonwettbewerb mit Freunden, Familie oder Team.',
    primaryCta: 'Kostenlos starten',
    trustA: 'Kostenlos, kein Glücksspiel',
    trustB: 'Live Wertung',
    trustC: 'Private Gruppen',
    cardResultLabel: 'Richtiges Ergebnis',
    cardBoostTitle: 'Boost aktiv',
    cardBoostSubtitle: '×2 Punkte in diesem Spiel',
    cardRankTitle: 'Du bist auf Platz 2',
    cardRankSubtitle: 'Mitgruender-Liga',
  },
  pt: {
    line1: 'Preve o futebol.',
    accent: 'Compete',
    underline: 'com amigos.',
    lede:
      'O Zporti transforma cada jogo numa disputa da temporada com amigos, familia ou equipa.',
    primaryCta: 'Comecar gratis',
    trustA: 'Gratis, sem apostas',
    trustB: 'Pontuacao ao vivo',
    trustC: 'Grupos privados',
    cardResultLabel: 'Resultado correto',
    cardBoostTitle: 'Boost ativo',
    cardBoostSubtitle: '×2 pontos neste jogo',
    cardRankTitle: 'Subiste para #2',
    cardRankSubtitle: 'Liga dos cofundadores',
  },
  zh: {
    line1: '预测足球。',
    accent: '和朋友',
    underline: '一起竞争。',
    lede:
      'Zporti 把每场比赛变成整个赛季的竞赛，你可以和朋友、家人或团队一起参与。',
    primaryCta: '免费开始',
    trustA: '免费参与，无赌博',
    trustB: '实时积分',
    trustC: '私密群组',
    cardResultLabel: '结果正确',
    cardBoostTitle: '加成已激活',
    cardBoostSubtitle: '本场比赛积分 ×2',
    cardRankTitle: '你已升至第 2 名',
    cardRankSubtitle: '联合创始人联赛',
  },
}
